/**
 * A config containing properties for wizard steps and substeps
 */
var WizardStepConfig = /** @class */ (function () {
    function WizardStepConfig() {
    }
    return WizardStepConfig;
}());
export { WizardStepConfig };
//# sourceMappingURL=wizard-step-config.js.map